/**
 * The type of the `IEditor`.
 */
export const EditorType = {
  ICodeEditor: 'vs.editor.ICodeEditor',
  IDiffEditor: 'vs.editor.IDiffEditor'
};